import { supabaseClient } from './supabase'

export function addRealTimeListener({
  table,
  callback,
}: {
  table: string
  callback(payload: {
    [key: string]: any
    type: 'broadcast'
    event: string
  }): void
}) {
  return supabaseClient
    .channel('custom-all-channel')
    .on(
      'postgres_changes',
      // @ts-ignore
      { event: '*', schema: 'public', table: table },
      callback
    )
    .subscribe()
}
